
import Vue from "vue";
import Loader from "@/components/Multiloader.vue";
import Gallery, { ResourceMeta } from "@/components/Gallery.vue";
import PrintButton from "@/components/PrintButton.vue";

export default Vue.extend({
  name: "Stammdaten",
  components: {
    Loader,
    Gallery,
    PrintButton
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      viewsToLoad: [
        {
          name: "messstellen_grundwasser_stammdaten",
          condition: "messstellennummer=number:" + this.id
        },
        {
          name: "messstellen_grundwasser_stockwerk",
          condition: "messstellennummer=number:" + this.id
        },
        {
          name: "messstellen_grundwasser_m_messst_allg_karte",
          condition: "messstellennummer=number:" + this.id
        }
      ],
      data: {} as any,
      imageResourceMeta: {
        application: "grundwasser",
        resource: "foto",
        id: this.id
      } as ResourceMeta
    };
  },
  methods: {
    round(value: any) {
      return !isNaN(value) ? Math.round(value) : value;
    },
    onLoaded(dataArray: any[]) {
      this.data = Object.assign({}, ...dataArray);
      // fire event with entity type to main component
      this.$parent?.$parent?.$parent?.$emit("type", this.data.messstellenart);
    }
  }
});
